// extracted by mini-css-extract-plugin
module.exports = {"reservation":"ShopCardLargeFooter_reservation__MisOf"};